import React, { useEffect, useState } from "react";
import moment from 'moment-jalaali'
import { Form, Select } from 'antd';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import DatePicker from 'react-datepicker2'
import ValidatorHelper from "../helpers/ValidatorHelper";
import { useNavigate  } from "react-router-dom";
import UserServices from "../../services/UserServices";
import { usePersistedStore } from "../../store/persisted-store";

export default function UserFilter(params) {
    const [form] = Form.useForm();
    const { getAgentsWagePaid, business, users: usersState, FILTERED_ITEM, FILTER_USERS, GET_PROMOTERS } = usePersistedStore()
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const navigate = useNavigate();
    const users = usersState.promoters;
    const usersLoading = usersState.loading;
    const loading = business.agentPaid.loading;
    const currentBusiness = business.currentBusiness;
    const filteredItem = usersState.filteredItem;
    const usersData = usersState.data;

    const { token } = currentBusiness;

    useEffect(() => {
        if (token) {
            form.resetFields();
        }
    }, [token])

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
        // dispatch(getPromoters());


        UserServices.getPromoters(token).then((res) => {
            GET_PROMOTERS(res.data.Promoters)
            filterUsers(filteredItem)
        }).catch((error) => {

        })
    }, [navigate, token])
    function filterUsers(value) {
        const payload = usersData.filter(item => {
            return (item.DisplayName && item.DisplayName.includes(value)) ||
                (item.Username && item.Username.includes(value));
        });
        FILTERED_ITEM(value)
        FILTER_USERS(payload)
    }

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {

        getAgentsWagePaid({
            // fromDate: values.fromDate && moment(values.fromDate).format(),
            // toDate: values.toDate && moment(values.toDate).format(),
            FromDate: convertToMoment(fromDate),
            ToDate: convertToMoment(toDate),
            userName: users.filter(user => user.UserName === values.UserName)[0].UserName
        });
    }

    return (
        <Form
            form={form}
            initialValues={{
                branch: params.branchId,
                user: "all",
                fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months'),
                toDate: params.toDate && moment(params.toDate)
            }}
            layout="inline" onFinish={onFinish}>
            <Form.Item
                name='UserName'
                rules={ValidatorHelper.required('انتخاب کاربر')}
                label="کاربران:">
                <Select
                    showSearch
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    loading={usersLoading}
                    disabled={!users.length}
                    style={{ minWidth: 270 }}>
                    {users && users.map((name, index) => {
                        return <Select.Option key={index} value={name.UserName}>{name.UserName}</Select.Option>
                    })}
                </Select>
            </Form.Item>
            <Form.Item
                name='fromDate'
                label='از تاریخ'>
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
            </Form.Item>
            <Form.Item
                name='toDate'
                label='تا تاریخ'>
                <DatePicker
                    value={toDate}
                    onChange={setToDate}
                    calendar={persian}
                    locale={persian_fa}
                    format="YYYY/MM/DD"
                    inputClass="datepicker-input"
                    calendarPosition="bottom-right"
                    portal
                    zIndex={1070}
                />
            </Form.Item>
            <Form.Item label=" " colon={false}>
                <button
                    style={{
                        float: "left",
                        padding: "0 10px",
                        height: 33,
                    }}
                    disabled={loading} type="primary"
                    className="btn btn-primary waves-effect waves-light" htmltype="submit">جستجو&nbsp;&nbsp;&nbsp;
                    <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                </button>

            </Form.Item>
        </Form>
    )
}